// Helper function to extract the video ID
export function extractVideoId(url: string): string {
  const match = url.match(
    /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([^\s&]+)/i
  );
  return match && match[1] ? match[1] : '';
}
